
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hzK4Z", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ccb972f8f1c5733b$export$6503ec6e8aabbaf; }, function (v) { return $ccb972f8f1c5733b$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ccb972f8f1c5733b$export$f7ad0328861e2f03; }, function (v) { return $ccb972f8f1c5733b$export$f7ad0328861e2f03 = v; });
var $ccb972f8f1c5733b$export$6503ec6e8aabbaf;
var $ccb972f8f1c5733b$export$f7ad0328861e2f03;
"use strict";
var $ccb972f8f1c5733b$var$mapping = new Map();
function $ccb972f8f1c5733b$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ccb972f8f1c5733b$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ccb972f8f1c5733b$var$resolve(id) {
    var resolved = $ccb972f8f1c5733b$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ccb972f8f1c5733b$export$6503ec6e8aabbaf = $ccb972f8f1c5733b$var$register;
$ccb972f8f1c5733b$export$f7ad0328861e2f03 = $ccb972f8f1c5733b$var$resolve;

});

parcelRegister("4m9Pp", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $32c0d72e2f6110e1$export$bdfd709ae4826697; }, function (v) { return $32c0d72e2f6110e1$export$bdfd709ae4826697 = v; });
var $32c0d72e2f6110e1$export$bdfd709ae4826697;
var $32c0d72e2f6110e1$export$c9e73fbda7da57b6;
var $32c0d72e2f6110e1$export$5a759dc7a1cfb72a;
"use strict";
var $32c0d72e2f6110e1$var$bundleURL = {};
function $32c0d72e2f6110e1$var$getBundleURLCached(id) {
    var value = $32c0d72e2f6110e1$var$bundleURL[id];
    if (!value) {
        value = $32c0d72e2f6110e1$var$getBundleURL();
        $32c0d72e2f6110e1$var$bundleURL[id] = value;
    }
    return value;
}
function $32c0d72e2f6110e1$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $32c0d72e2f6110e1$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $32c0d72e2f6110e1$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $32c0d72e2f6110e1$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$32c0d72e2f6110e1$export$bdfd709ae4826697 = $32c0d72e2f6110e1$var$getBundleURLCached;
$32c0d72e2f6110e1$export$c9e73fbda7da57b6 = $32c0d72e2f6110e1$var$getBaseURL;
$32c0d72e2f6110e1$export$5a759dc7a1cfb72a = $32c0d72e2f6110e1$var$getOrigin;

});

var $2da131456cfcb86a$exports = {};


(parcelRequire("hzK4Z")).register((parcelRequire("4m9Pp")).getBundleURL("fiRrv"), JSON.parse('["fiRrv","404.5b92fa53.js","9Qmeo","app-switcher.802c32f5.js","XbROL","segment-highlight.956334f5.js","jekdm","robot-error.73e032eb.js","fVDSN","atlassian-switcher.fc4247d2.js","ese7D","cs.9a229108.js","3NRwY","da.fef745a3.js","dodfE","de.8c598faf.js","21MAE","en_GB.92311fb9.js","dsQcR","en_ZZ.a01b6a33.js","24WHr","en.ca77b671.js","4rqjG","es.e468eeaf.js","4MDfk","et.90e4790b.js","4adIB","fi.6493d10a.js","9uWoV","fr.16320b8d.js","hroyB","hu.1dfe4880.js","eclDA","is.dbf516ac.js","eSqbq","it.2379c9a8.js","jljC8","ja.32d97c5d.js","1KFXE","ko.81e19898.js","e3fl4","nb.b41cceb5.js","aeqDM","nl.7013462e.js","aA8Qw","pl.eaeb4ad9.js","iBbEp","pt_BR.ec698710.js","7f42P","pt_PT.ca114a3d.js","6f5tx","ro.17aba28d.js","9TEey","ru.0acfdcc0.js","55S30","sk.42c5d97c.js","vRZTJ","sv.0169e390.js","9xZ4q","th.00d0137b.js","7pbcB","tr.2512eeda.js","kgoYW","uk.73e28202.js","2yIN2","vi.8587d94f.js","58F85","zh_TW.66cc47d8.js","4u7GX","zh.524873af.js","iuDlq","jira-switcher.d55592f3.js","51okE","view.cb36ae61.js","jlk5k","jira-switcher.9e070b95.js","99ccA","animation-illustration.bd2edd37.js","fK0bx","animation-illustration.013071ec.js","8DJFA","jira-switcher.6719e194.js","5qV5c","jira-switcher.9ae6b756.js","cu4en","jira-switcher.0b241c3a.js","Ay9Wt","jira-switcher.runtime.7d97f773.js","Ay9Wt","jira-switcher.runtime.7d97f773.js","4R0Pi","confluence-switcher.18a8defb.js","4YpzE","generic-switcher.2b7a3b39.js","2ALIQ","view.dfa4499f.js","1Csux","app-switcher.41d92082.js","7MAYM","app-switcher.c2fb4c85.js","bVPXk","app-switcher.419548a8.js"]'));


//# sourceMappingURL=404.runtime.cf4ed61f.js.map
